import { render, staticRenderFns } from "./PaymentDebitsEditForm.vue?vue&type=template&id=51be6315"
import script from "./PaymentDebitsEditForm.vue?vue&type=script&lang=js"
export * from "./PaymentDebitsEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports